import React from 'react';
import { string, bool, shape } from 'prop-types';
import classnames from 'classnames';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';
import { Image } from 'components';
import './PrimaryCharacteristic.scss';

const messages = defineMessages({
    altProLogo: {
        id: 'listing.productCard.primaryCharacteristic.altProLogo',
        defaultMessage: 'Manomano pro logo',
        description:
            'alt message (accessibility) of pro logo in primary characteristic product card',
    },
    altBingoLogo: {
        id: 'listing.productCard.primaryCharacteristic.altBingoLogo',
        defaultMessage: 'Manomano bingo logo',
        description:
            'alt message (accessibility) of bingo logo in primary characteristic product card',
    },
});

export default function PrimaryCharacteristic({
    className,
    isB2B,
    isProProduct,
    hasBingo,
    isMFProduct,
    cdn,
    lazyload,
}) {
    const intl = useIntl();
    const rootClassnames = classnames('primary-characteristic', className);

    const shouldShowBingoLogo = !isB2B && hasBingo && isMFProduct;
    const shouldShowProLogo = isB2B && isProProduct;
    let srcLogo = null;
    let altLogo;
    if (shouldShowProLogo) {
        srcLogo = `${cdn.CDN_IMAGE}/themes/b2b/svg/logos/logo-pro.svg`;
        altLogo = intl.formatMessage(messages.altProLogo);
    } else if (shouldShowBingoLogo) {
        srcLogo = `${cdn.CDN_IMAGE}/themes/default/svg/logos/bingo.svg`;
        altLogo = intl.formatMessage(messages.altBingoLogo);
    }

    const imageClassnames = classnames('primary-characteristic__image', {
        'primary-characteristic__image--bingo': shouldShowBingoLogo,
        'primary-characteristic__image--pro': shouldShowProLogo,
    });

    return (
        (shouldShowBingoLogo ||
            shouldShowProLogo ||
            (isMFProduct && !isB2B)) && (
            <div className={rootClassnames}>
                {(shouldShowBingoLogo || shouldShowProLogo) && (
                    <Image
                        className={imageClassnames}
                        alt={altLogo}
                        src={srcLogo}
                        cdn={cdn}
                        lazyload={lazyload}
                    />
                )}
                <span className="primary-characteristic__text">
                    {isMFProduct && (
                        <FormattedMessage
                            id="listing.productCard.primaryCharacteristic.bingoLabel"
                            defaultMessage="Speed delivery and free by ManoMano"
                            description="label of bingo in primary characteristic product card"
                        />
                    )}
                    {shouldShowProLogo && (
                        <FormattedMessage
                            id="listing.productCard.primaryCharacteristic.proLabel"
                            defaultMessage="Price and services reserved to pro"
                            description="label of pro in primary characteristic product card"
                        />
                    )}
                </span>
            </div>
        )
    );
}

PrimaryCharacteristic.propTypes = {
    className: string,
    isB2B: bool,
    isProProduct: bool,
    hasBingo: bool,
    isMFProduct: bool,
    cdn: shape({
        CDN_IMAGE: string,
    }).isRequired,
    lazyload: bool,
};

PrimaryCharacteristic.defaultProps = {
    className: null,
    isB2B: false,
    isProProduct: false,
    hasBingo: false,
    isMFProduct: false,
    lazyload: false,
};
